import { Container, Text } from "@/ui"
import { normalizeNode } from "./normalizer"

const ContactsUtilsNode = ({ node }) => {
	const normalizedNode = normalizeNode(node)
	const { adresse, phone, email, website } = normalizedNode

	return (
		<Container className="py-11">
			<div>
				<Text>{adresse}</Text>
			</div>
			<div>
				<Text>{phone}</Text>
			</div>
			<div>
				<Text>{email}</Text>
			</div>
			<div>
				<Text>{website}</Text>
			</div>
		</Container>
	)
}
export default ContactsUtilsNode

export const config = {
	id: "node--contacts_utiles",
	params: {
		fields: {
			"node--contacts_utiles":
				"field_vactory_address,field_vactory_email,field_vactory_taxonomy_2,field_vactory_website,field_vactory_taxonomy_3,field_vactory_telephone",
			"taxonomy_term--field_vactory_taxonomy_3": "name",
			"taxonomy_term--field_vactory_taxonomy_2": "name",
		},
		include: "field_vactory_taxonomy_3,field_vactory_taxonomy_2",
	},
}
